import reducer from "./reducers";

import * as patientAction from "./actions";

export { patientAction };

export default reducer;
